/// <reference path="../../app.typings.d.ts" />
'use strict';
var app;
(function (app) {
    var Directives;
    (function (Directives) {
        var ApPageHeader = /** @class */ (function () {
            function ApPageHeader() {
                this.replace = false;
                this.restrict = 'A';
                this.scope = {};
                this.templateUrl = 'app/directives/ap-page-header/template.html';
                this.controller = Directives.ApPageHeaderController;
                this.controllerAs = 'ctrl';
            }
            ApPageHeader.factory = function () {
                var directive = function () {
                    return new ApPageHeader();
                };
                directive['$inject'] = [];
                return directive;
            };
            return ApPageHeader;
        }());
        angular
            .module('app.Directives')
            .directive('apPageHeader', ApPageHeader.factory());
    })(Directives = app.Directives || (app.Directives = {}));
})(app || (app = {}));
